
import { Component, Prop, Vue } from 'vue-property-decorator'

import VLazyImage from 'v-lazy-image/v2'

@Component({
  components: {
    VLazyImage
  }
})
export default class BacLazyImage extends Vue {
  @Prop({ required: true }) src!: string
  @Prop({ required: false, default: '' }) version!: string
  @Prop({ required: false, default: false }) legacy!: boolean // loads image normally
  @Prop({ required: false, default: false }) scrollLoad!: boolean
  @Prop({ required: false, default: false }) lazyLoad!: boolean

  resolution = 'low'
  get imageUrl () {
    if (this.resolution === 'high' || this.legacy) {
      return this.legacy || `${this.src}_mid.jpg?${this.version}`
    } else {
      return `${this.src}_low.jpg?${this.version}`
    }
  }
}
